import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/6a7122d18295d50014b89239_1787844047403_1b5ae3db/edurise/src/app/not-found.tsx");
